import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeStyle as _normalizeStyle, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, withCtx as _withCtx } from "vue"

const _hoisted_1 = { style: {"width":"392px"} }
const _hoisted_2 = { class: "overlay-wrapper card-rounded min-h-225px overflow-hidden h-275px border border-1" }
const _hoisted_3 = {
  key: 0,
  class: "w-100 h-100 d-flex justify-content-center align-items-center bg-gray-200"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 2,
  class: "w-100 h-100 d-flex justify-content-center align-items-center bg-gray-200"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h1", {
  class: "text-black-50 opacity-20 fs-1",
  style: {"transform":"rotate(45deg)"}
}, " User has not uploaded this file yet ", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "overlay-layer bg-dark card-rounded bg-opacity-25" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-eye-fill fs-2x text-white" })
], -1)
const _hoisted_9 = { class: "m-0 px-1" }
const _hoisted_10 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_11 = {
  href: "#",
  class: "fs-4 text-dark fw-bold text-hover-primary text-dark lh-base me-1"
}
const _hoisted_12 = { class: "d-flex align-items-center" }
const _hoisted_13 = {
  key: 3,
  class: "text-primary me-4 fw-bold fs-3"
}
const _hoisted_14 = {
  key: 4,
  class: "text-danger me-4 fw-bold fs-3"
}
const _hoisted_15 = { class: "fw-semibold fs-5 text-gray-600 text-dark mt-3 d-flex" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h3", { class: "text-danger me-4" }, "Reason:", -1)
const _hoisted_17 = { class: "" }
const _hoisted_18 = { class: "mb-5" }
const _hoisted_19 = { class: "fs-4 text-dark fw-bold text-hover-primary text-dark lh-base me-1" }

import VuePdfEmbed from "vue-pdf-embed";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import { inject, onMounted, Ref, ref, watch } from "vue";
import {
  FileFormatTypes,
  getContentTypeFromMedia,
} from "@/core/types/FileFormatTypes";
import { getImageUrl } from "@/core/plugins/ProcessImageLink";
import { Check, Close, Delete } from "@element-plus/icons-vue";
import InjectKeys from "@/core/types/TenantGlobalInjectionKeys";
import TenantGlobalService from "@/projects/tenant/services/TenantGlobalService";
import UserService from "@/projects/tenant/modules/users/services/UserService";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'UserImageIdsDoc',
  props: {
    title: {},
    descp: {},
    medias: {},
    enableDelete: { type: Boolean },
    verificationDetails: {},
    context: {}
  },
  emits: ["fileDeleted"],
  setup(__props: any, { emit: emits }) {

const props = __props;





const selectedMedia = ref(props.medias[0] ?? {});
const contentType = ref(FileFormatTypes.JPEG);
const selectedId = ref(0);
const unApprovedDocuments = ref(0);
const isLoading = ref(false);
const handleSelectMedia = async (idx: number) => {
  selectedMedia.value = props.medias[idx] ?? null;
  contentType.value = getContentTypeFromMedia(selectedMedia.value);
  if (selectedMedia.value) await getContentUrlWithToken();
};

watch(
  () => props.medias,
  async () => await handleSelectMedia(0)
);

const contentUrlWithToken = ref("");
const getContentUrlWithToken = async () => {
  if (!selectedMedia.value) return;
  isLoading.value = true;
  contentUrlWithToken.value = await TenantGlobalService.getImageUrlWithToken(
    getImageUrl(selectedMedia.value?.guid)
  );
  isLoading.value = false;
};

const openConfirmModal = inject(InjectKeys.OPEN_CONFIRM_MODAL);

const openRejectModal = inject(
  InjectKeys.OPEN_REJECT_REASON_MODAL,
  (formData: any) => MsgPrompt.error("Get Modal Failed")
);

const handleRejectDocument = () => {
  openRejectModal((formData: any) =>
    UserService.rejectUserDocument(
      props.verificationDetails.id,
      selectedMedia.value.id,
      formData
    )
      .then(() => MsgPrompt.success("Document Rejected Successfully"))
      .then(() => emits("fileDeleted"))
  );
};

const fileShowRef = inject<Ref>(InjectKeys.FILE_SHOW_REF);

const handleMouseEnter = async (media) => {
  if (!media) return;
  isLoading.value = true;
  await fileShowRef?.value?.show(media);
  isLoading.value = false;
};

const handleApproveDocument = () => {
  openConfirmModal?.(
    () =>
      UserService.approveUserDocument(
        props.verificationDetails.id,
        selectedMedia.value.id
      )
        .then(() => MsgPrompt.success("Document Approved Successfully"))
        .then(() => emits("fileDeleted")),
    undefined,
    {
      confirmText: "Confirm to approve this document?",
      confirmColor: "success",
    }
  );
};

const deleteFile = () => {
  openConfirmModal?.(
    () =>
      UserService.deleteVerificationDocForUser(
        props.verificationDetails.id,
        selectedMedia.value.id
      ).then(() => emits("fileDeleted")),
    undefined,
    {
      confirmText: "Confirm to delete this document?",
      confirmColor: "warning",
    }
  );
};

onMounted(async () => {
  unApprovedDocuments.value = props.medias.filter(
    (media) => media.status === 0
  ).length;
  await handleSelectMedia(0);
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (handleMouseEnter(selectedMedia.value))),
      class: "d-block overlay mb-4",
      "data-fslightbox": "lightbox-hot-sales",
      href: "#"
    }, [
      _createElementVNode("div", _hoisted_2, [
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(ScaleLoader, { color: '#ffc730' })
            ]))
          : (selectedMedia.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (
              [
                _unref(FileFormatTypes).JPEG,
                _unref(FileFormatTypes).JPG,
                _unref(FileFormatTypes).PNG,
              ].includes(contentType.value as any)
            )
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "w-100 overlay-wrapper bgi-no-repeat bgi-position-center bgi-size-cover card-rounded h-275px",
                      style: _normalizeStyle(
              contentUrlWithToken.value !== ''
                ? `background-image: url(${contentUrlWithToken.value});`
                : ''
            )
                    }, null, 4))
                  : (
              [_unref(FileFormatTypes).PDF].includes(contentType.value  as any) &&
              contentUrlWithToken.value !== ''
            )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createVNode(_unref(VuePdfEmbed), {
                          source: contentUrlWithToken.value,
                          class: ""
                        }, null, 8, ["source"])
                      ]))
                    : _createCommentVNode("", true)
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
      ]),
      _hoisted_8
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", null, [
          _createElementVNode("a", _hoisted_11, _toDisplayString(_ctx.title), 1),
          _createVNode(_component_el_select, {
            class: "w-125px ms-5",
            modelValue: selectedId.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedId).value = $event)),
            onChange: _cache[2] || (_cache[2] = ($event: any) => (handleSelectMedia(selectedId.value)))
          }, {
            default: _withCtx(() => [
              (props.medias?.length === 0)
                ? (_openBlock(), _createBlock(_component_el_option, {
                    key: 0,
                    label: "-- none --",
                    value: 0
                  }))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.medias, (option, idx) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: idx,
                  label: option.fileName as string,
                  value: idx
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          (selectedMedia.value?.status === 0)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                onClick: handleApproveDocument,
                type: "success",
                icon: _unref(Check) as any,
                circle: ""
              }, null, 8, ["icon"]))
            : _createCommentVNode("", true),
          (selectedMedia.value?.status === 0)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                onClick: handleRejectDocument,
                type: "danger",
                icon: _unref(Close) as any,
                circle: ""
              }, null, 8, ["icon"]))
            : _createCommentVNode("", true),
          (props.enableDelete ?? false)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 2,
                onClick: deleteFile,
                type: "warning",
                icon: _unref(Delete) as any,
                circle: ""
              }, null, 8, ["icon"]))
            : _createCommentVNode("", true),
          (selectedMedia.value?.status === 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, " Approved "))
            : _createCommentVNode("", true),
          (selectedMedia.value?.status === 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, " Rejected "))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        (selectedMedia.value?.status === 3)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_16,
              _createElementVNode("p", _hoisted_17, _toDisplayString(selectedMedia.value.rejectedReason), 1)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.context), 1)
      ])
    ])
  ]))
}
}

})